import React, { Component } from 'react';
import { EventEmitter } from 'fbemitter';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Footer from '../../Components/Footer/Footer';
import auth from '../Authentication/Auth';
import FuelTankList from '../FuelTanks/FuelTankList';

// This is here until we allow users to select/create multiple fuel farms
import FirstFuelFarm from '../../Services/FirstFuelFarm';

const authEvents = new EventEmitter();

class FuelFarmPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fuelFarm: null,
    };

    this.getFirsFuelFarm = this.getFirsFuelFarm.bind(this);
  }

  componentWillMount() {
    this.getFirsFuelFarm(this);
  }

  getFirsFuelFarm() {
    FirstFuelFarm.get({ fboId: this.props.fboId })
      .then((fuelFarm) => {
        this.setState({ fuelFarm });
      }).catch((err) => {
        console.log(err);
      });
  }

  handleToggle() {
    this.setState({ drawerOpen: !this.state.drawerOpen })
  }

  renderLoading() {
    return (
      <main className="page-content">
        <div className="normal-page-header">
          <h1 className="left">Fuel Farm</h1>
          <div className="clear" />
        </div>
        <section className="page-content-items">
          Loading Fuel Farm
        </section>
        <Footer/>
      </main>
    );
  };

  renderFuelTanks() {
    const createState = {
      fboId: this.props.fboId,
      fuelFarmId: this.state.fuelFarm.id,
    };

    return (
      <main className="page-content">
        <div className="normal-page-header">
          <h1 className="left">{this.state.fuelFarm.name}</h1>
          <Link
            to={{ pathname:`/fuelfarm/${this.state.fuelFarm.id}/fuelTank/new`, state: createState }}
            className="btn btn-medium btn-primary right"
            params={{ fboId: this.props.fboId, fuelFarmId: this.state.fuelFarm.id}}>
            <span className="mobile">+</span>
            <span className="desktop">Add Fuel Tank</span>
          </Link>
          <div className="clear" />
        </div>
        <FuelTankList fboId={this.props.fboId} ownerId={this.state.fuelFarm.id} ownerType="fuelfarm" />
        <Footer />
      </main>
    );
  }

  render() {
    return (
      <span>
        {this.state.fuelFarm !== null ? (
          this.renderFuelTanks()
        ) : (
          this.renderLoading()
        )}
      </span>
    );
  }
}


FuelFarmPage.propTypes = {
  fboId: PropTypes.number.isRequired,
};

export default FuelFarmPage;




// WEBPACK FOOTER //
// ./src/Containers/FuelFarm/FuelFarmPage.js